/** Verizon/Yahoo/Oath tag */
export function executeOathScript(isSuccessPage) {
  // This snippet is directly taken from the rails implementation
  /* eslint-disable*/
  (function (w, d, t, r, u) {
    w[u] = w[u] || [];
    w[u].push({ projectId: '10000', properties: { pixelId: '10053916' } });
    let s = d.createElement(t);
    s.src = r;
    s.async = true;
    s.onload = s.onreadystatechange = function () {
      let y;
      var rs = this.readyState;
      var c = w[u];
      if (rs && rs != 'complete' && rs != 'loaded') {
        return;
      }
      try {
        y = YAHOO.ywa.I13N.fireBeacon;
        w[u] = [];
        w[u].push = function (p) {
          y([p]);
        };
        y(c);
      } catch (e) {}
    };
    let scr = d.getElementsByTagName(t)[0];
    var par = scr.parentNode;
    par.insertBefore(s, scr);
  })(window, document, 'script', 'https://s.yimg.com/wi/ytc.js', 'dotq');
  /* eslint-enable */

  if (isSuccessPage) {
    window.dotq = window.dotq || [];

    /** Custom event to indicate enrollment conversion */
    window.dotq.push({
      projectId: '10000',
      properties: {
        pixelId: '10053916',
        qstrings: {
          et: 'custom',
          ec: 'conversion',
        },
      },
    });
  }
}

export function loadGoogleAnalytics(isSuccessPage) {
  /* eslint-disable */
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    (i[r] =
      i[r] ||
      function () {
        (i[r].q = i[r].q || []).push(arguments);
      }),
      (i[r].l = 1 * new Date());
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(
    window,
    document,
    'script',
    'https://www.google-analytics.com/analytics.js',
    'ga'
  );
  /* eslint-enable */

  const { ga } = window;
  ga('create', 'UA-62152209-7', 'auto');
  ga('send', 'pageview');

  if (isSuccessPage) {
    ga('send', 'event', {
      eventCategory: 'Enrollment',
      eventAction: 'SuccessPageViewed',
    });
  }
}

/*
**** WARNING: ONLY LOAD GOOGLE TAG MANAGER AT THE END OF ENROLLMENT ****
GTM can be used to inject code and break enrollment (it has happened before)!
We can only tolerate this after enrollment is completed
*/
export function loadGoogleTagManager() {
  /* eslint-disable */
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0];
    var j = d.createElement(s);
    var dl = l != 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-N3Z9ZNR');
  /* eslint-enable */
}

export function fireGtmCustomEvent(trigger) {
  window.dataLayer = window.dataLayer || [];
  if (window.dataLayer.push) {
    window.dataLayer.push(trigger);
  }
}

export function fireGtmDataLayerVariable(dataLayerVariableObj) {
  window.dataLayer = window.dataLayer || [];
  if (window.dataLayer.push) {
    window.dataLayer.push(dataLayerVariableObj);
  }
}

export function fireBingCustomConversionEvent() {
  /** Bing conversions custom event */
  window.uetq = window.uetq || [];

  window.uetq.push('event', 'successPageViewed', {
    event_category: 'Enrollment',
  });
}

export function loadChimeDotComEnrollmentSuccess() {
  /**
   * Load www.chime.com/enrollment-success in a hidden iframe to trigger the anonymous id cookie
   * and local storage deletion, to avoid sharing the anonymous id between different members.
   */
  const { CHIME_DOT_COM_URL } = window.Chime.config;
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = CHIME_DOT_COM_URL + '/enrollment-success';
  document.body.appendChild(iframe);
}
